import Vue from "vue";
import Router from "vue-router";

// modules

Vue.use(Router);
const baseRoutes = [];

import frontpageRoute from "../pages/front_page/modules/routes";
import contactpageRoute from "../pages/contact_page/modules/routes";
import newspageRoute from "../pages/news_page/modules/routes";
import trainingModulesroute from "../pages/training_modules/modules/routes";

const routes = baseRoutes.concat(
  trainingModulesroute,
  frontpageRoute,
  contactpageRoute,
  newspageRoute
);
const router = new Router({
  routes: routes
});

export default router;
